// Defines donation step order per the v1 donation flow
export enum stepV1 {
  LOADING = 0,
  DONATION_TYPE = 1,
  INFORMATION = 2,
  CASE = 3,
  DONOR = 4,
  DONATION_DETAILS = 5,
  PAYMENT_AND_DELIVERY = 6,
  SUMMARY = 7,
  PAYMENT = 8,
  SUCCESS = 9,
  PAYMENT_LINK = 10,
}

// Defines donation step order per the v2 donation flow
export enum stepV2 {
  LOADING = 0,
  DONATION_TYPE = 1,
  INFORMATION = 2,
  CASE = 3,
  CERTIFICATE_DETAILS = 4,
  PAYMENT_AND_DELIVERY = 5,
  SUMMARY = 6,
  PAYMENT = 7,
  SUCCESS = 8,
  PAYMENT_LINK = 9,
}
